import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import TouchPan from "../../directives/TouchPan.js";
import DarkMixin from "../../mixins/dark.js";
import FormMixin from "../../mixins/form.js";
import { between } from "../../utils/format.js";
import { position } from "../../utils/event.js";
import { isNumber, isObject } from "../../utils/is.js";
var markerPrefixClass = 'q-slider__marker-labels';

var defaultMarkerConvertFn = function defaultMarkerConvertFn(v) {
  return {
    value: v
  };
}; // PGDOWN, LEFT, DOWN, PGUP, RIGHT, UP


export var keyCodes = [34, 37, 40, 33, 39, 38];
export var SliderMixin = {
  mixins: [DarkMixin, FormMixin],
  directives: {
    TouchPan: TouchPan
  },
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    hideSelection: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [Boolean, Number],
    markerLabels: [Boolean, Array, Object, Function],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
      type: String,
      default: '20px'
    },
    trackSize: {
      type: String,
      default: '4px'
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [String, Number],
    thumbColor: String,
    thumbPath: {
      type: String,
      default: 'M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0'
    }
  },
  data: function data() {
    return {
      active: false,
      preventFocus: false,
      focus: false,
      dragging: false
    };
  },
  computed: {
    axis: function axis() {
      return this.vertical === true ? '--v' : '--h';
    },
    labelSide: function labelSide() {
      return '-' + (this.switchLabelSide === true ? 'switched' : 'standard');
    },
    isReversed: function isReversed() {
      return this.vertical === true ? this.reverse === true : this.reverse !== (this.$q.lang.rtl === true);
    },
    computedInnerMin: function computedInnerMin() {
      return this.__getInnerMin(this.innerMin);
    },
    computedInnerMax: function computedInnerMax() {
      return this.__getInnerMax(this.innerMax);
    },
    editable: function editable() {
      return this.disable !== true && this.readonly !== true && this.computedInnerMin < this.computedInnerMax;
    },
    computedDecimals: function computedDecimals() {
      return (String(this.step).trim('0').split('.')[1] || '').length;
    },
    computedStep: function computedStep() {
      return this.step === 0 ? 1 : this.step;
    },
    computedTabindex: function computedTabindex() {
      return this.editable === true ? this.tabindex || 0 : -1;
    },
    trackLen: function trackLen() {
      return this.max - this.min;
    },
    innerBarLen: function innerBarLen() {
      return this.computedInnerMax - this.computedInnerMin;
    },
    innerMinRatio: function innerMinRatio() {
      return this.__convertModelToRatio(this.computedInnerMin);
    },
    innerMaxRatio: function innerMaxRatio() {
      return this.__convertModelToRatio(this.computedInnerMax);
    },
    positionProp: function positionProp() {
      return this.vertical === true ? this.isReversed === true ? 'bottom' : 'top' : this.isReversed === true ? 'right' : 'left';
    },
    sizeProp: function sizeProp() {
      return this.vertical === true ? 'height' : 'width';
    },
    thicknessProp: function thicknessProp() {
      return this.vertical === true ? 'width' : 'height';
    },
    orientation: function orientation() {
      return this.vertical === true ? 'vertical' : 'horizontal';
    },
    attributes: function attributes() {
      var acc = {
        role: 'slider',
        'aria-valuemin': this.computedInnerMin,
        'aria-valuemax': this.computedInnerMax,
        'aria-orientation': this.orientation,
        'data-step': this.step
      };

      if (this.disable === true) {
        acc['aria-disabled'] = 'true';
      } else if (this.readonly === true) {
        acc['aria-readonly'] = 'true';
      }

      return acc;
    },
    classes: function classes() {
      return "q-slider q-slider".concat(this.axis, " q-slider--").concat(this.active === true ? '' : 'in', "active inline no-wrap ") + (this.vertical === true ? 'row' : 'column') + (this.disable === true ? ' disabled' : ' q-slider--enabled' + (this.editable === true ? ' q-slider--editable' : '')) + (this.focus === 'both' ? ' q-slider--focus' : '') + (this.label || this.labelAlways === true ? ' q-slider--label' : '') + (this.labelAlways === true ? ' q-slider--label-always' : '') + (this.isDark === true ? ' q-slider--dark' : '') + (this.dense === true ? ' q-slider--dense q-slider--dense' + this.axis : '');
    },
    selectionBarClass: function selectionBarClass() {
      var color = this.selectionColor || this.color;
      return 'q-slider__selection absolute' + (color !== void 0 ? " text-".concat(color) : '');
    },
    markerClass: function markerClass() {
      return this.__getAxisClass('markers') + ' absolute overflow-hidden';
    },
    trackContainerClass: function trackContainerClass() {
      return this.__getAxisClass('track-container');
    },
    pinClass: function pinClass() {
      return this.__getPositionClass('pin');
    },
    labelClass: function labelClass() {
      return this.__getPositionClass('label');
    },
    textContainerClass: function textContainerClass() {
      return this.__getPositionClass('text-container');
    },
    markerLabelsContainerClass: function markerLabelsContainerClass() {
      return this.__getPositionClass('marker-labels-container') + (this.markerLabelsClass !== void 0 ? " ".concat(this.markerLabelsClass) : '');
    },
    trackClass: function trackClass() {
      return 'q-slider__track relative-position no-outline' + (this.trackColor !== void 0 ? " bg-".concat(this.trackColor) : '');
    },
    trackStyle: function trackStyle() {
      var acc = _defineProperty({}, this.thicknessProp, this.trackSize);

      if (this.trackImg !== void 0) {
        acc.backgroundImage = "url(".concat(this.trackImg, ") !important");
      }

      return acc;
    },
    innerBarClass: function innerBarClass() {
      return 'q-slider__inner absolute' + (this.innerTrackColor !== void 0 ? " bg-".concat(this.innerTrackColor) : '');
    },
    innerBarStyle: function innerBarStyle() {
      var _acc2;

      var acc = (_acc2 = {}, _defineProperty(_acc2, this.positionProp, "".concat(100 * this.innerMinRatio, "%")), _defineProperty(_acc2, this.sizeProp, "".concat(100 * (this.innerMaxRatio - this.innerMinRatio), "%")), _acc2);

      if (this.innerTrackImg !== void 0) {
        acc.backgroundImage = "url(".concat(this.innerTrackImg, ") !important");
      }

      return acc;
    },
    markerStep: function markerStep() {
      return isNumber(this.markers) === true ? this.markers : this.computedStep;
    },
    markerTicks: function markerTicks() {
      var acc = [];
      var step = this.markerStep;
      var value = this.min;

      do {
        acc.push(value);
        value += step;
      } while (value < this.max);

      acc.push(this.max);
      return acc;
    },
    markerLabelClass: function markerLabelClass() {
      var prefix = " ".concat(markerPrefixClass).concat(this.axis, "-");
      return markerPrefixClass + "".concat(prefix).concat(this.switchMarkerLabelsSide === true ? 'switched' : 'standard') + "".concat(prefix).concat(this.isReversed === true ? 'rtl' : 'ltr');
    },
    markerLabelsList: function markerLabelsList() {
      var _this = this;

      if (this.markerLabels === false) {
        return null;
      }

      return this.__getMarkerList(this.markerLabels).map(function (entry, index) {
        return {
          index: index,
          value: entry.value,
          label: entry.label || entry.value,
          classes: _this.markerLabelClass + (entry.classes !== void 0 ? ' ' + entry.classes : ''),
          style: _objectSpread(_objectSpread({}, _this.__getMarkerLabelStyle(entry.value)), entry.style || {})
        };
      });
    },
    markerScope: function markerScope() {
      return {
        markerList: this.markerLabelsList,
        markerMap: this.markerLabelsMap,
        classes: this.markerLabelClass,
        getStyle: this.__getMarkerLabelStyle
      };
    },
    markerStyle: function markerStyle() {
      if (this.innerBarLen !== 0) {
        var size = 100 * this.markerStep / this.innerBarLen;
        return _objectSpread(_objectSpread({}, this.innerBarStyle), {}, {
          backgroundSize: this.vertical === true ? "2px ".concat(size, "%") : "".concat(size, "% 2px")
        });
      }

      return null;
    },
    markerLabelsMap: function markerLabelsMap() {
      if (this.markerLabels === false) {
        return null;
      }

      var acc = {};
      this.markerLabelsList.forEach(function (entry) {
        acc[entry.value] = entry;
      });
      return acc;
    },
    panDirectives: function panDirectives() {
      var _modifiers;

      return this.editable === true ? [{
        name: 'touch-pan',
        value: this.__onPan,
        modifiers: (_modifiers = {}, _defineProperty(_modifiers, this.orientation, true), _defineProperty(_modifiers, "prevent", true), _defineProperty(_modifiers, "stop", true), _defineProperty(_modifiers, "mouse", true), _defineProperty(_modifiers, "mouseAllDir", true), _modifiers)
      }] : null;
    }
  },
  methods: {
    __getInnerMin: function __getInnerMin(val) {
      return isNaN(val) === true || this.innerMin < this.min ? this.min : this.innerMin;
    },
    __getInnerMax: function __getInnerMax(val) {
      return isNaN(val) === true || val > this.max ? this.max : this.innerMax;
    },
    __getPositionClass: function __getPositionClass(name) {
      var cls = 'q-slider__' + name;
      return "".concat(cls, " ").concat(cls).concat(this.axis, " ").concat(cls).concat(this.axis).concat(this.labelSide);
    },
    __getAxisClass: function __getAxisClass(name) {
      var cls = 'q-slider__' + name;
      return "".concat(cls, " ").concat(cls).concat(this.axis);
    },
    __convertRatioToModel: function __convertRatioToModel(ratio) {
      var model = this.min + ratio * (this.max - this.min);

      if (this.step > 0) {
        var modulo = (model - this.min) % this.step;
        model += (Math.abs(modulo) >= this.step / 2 ? (modulo < 0 ? -1 : 1) * this.step : 0) - modulo;
      }

      if (this.computedDecimals > 0) {
        model = parseFloat(model.toFixed(this.computedDecimals));
      }

      return between(model, this.computedInnerMin, this.computedInnerMax);
    },
    __convertModelToRatio: function __convertModelToRatio(model) {
      return this.trackLen === 0 ? 0 : (model - this.min) / this.trackLen;
    },
    __getDraggingRatio: function __getDraggingRatio(evt, dragging) {
      var pos = position(evt),
          val = this.vertical === true ? between((pos.top - dragging.top) / dragging.height, 0, 1) : between((pos.left - dragging.left) / dragging.width, 0, 1);
      return between(this.isReversed === true ? 1.0 - val : val, this.innerMinRatio, this.innerMaxRatio);
    },
    __getMarkerList: function __getMarkerList(def) {
      var _this2 = this;

      if (def === false) {
        return null;
      }

      if (def === true) {
        return this.markerTicks.map(defaultMarkerConvertFn);
      }

      if (typeof def === 'function') {
        return this.markerTicks.map(function (value) {
          var item = def(value);
          return isObject(item) === true ? _objectSpread(_objectSpread({}, item), {}, {
            value: value
          }) : {
            value: value,
            label: item
          };
        });
      }

      var filterFn = function filterFn(_ref) {
        var value = _ref.value;
        return value >= _this2.min && value <= _this2.max;
      };

      if (Array.isArray(def) === true) {
        return def.map(function (item) {
          return isObject(item) === true ? item : {
            value: item
          };
        }).filter(filterFn);
      }

      return Object.keys(def).map(function (key) {
        var item = def[key];
        var value = Number(key);
        return isObject(item) === true ? _objectSpread(_objectSpread({}, item), {}, {
          value: value
        }) : {
          value: value,
          label: item
        };
      }).filter(filterFn);
    },
    __getMarkerLabelStyle: function __getMarkerLabelStyle(val) {
      return _defineProperty({}, this.positionProp, "".concat(100 * (val - this.min) / this.trackLen, "%"));
    },
    __getMarkerLabelsContent: function __getMarkerLabelsContent(h) {
      var _this3 = this;

      if (this.$scopedSlots['marker-label-group'] !== void 0) {
        return this.$scopedSlots['marker-label-group'](this.markerScope);
      }

      var fn = this.$scopedSlots['marker-label'];

      if (fn !== void 0) {
        return this.markerLabelsList.map(function (marker) {
          return fn(_objectSpread({
            marker: marker
          }, _this3.markerScope));
        });
      }

      return this.markerLabelsList.map(function (marker) {
        return h('div', {
          key: marker.value,
          style: marker.style,
          class: marker.classes
        }, marker.label);
      });
    },
    __onPan: function __onPan(event) {
      if (event.isFinal === true) {
        if (this.dragging !== void 0) {
          this.__updatePosition(event.evt); // only if touch, because we also have mousedown/up:


          event.touch === true && this.__updateValue(true);
          this.dragging = void 0;
          this.$emit('pan', 'end');
        }

        this.active = false;
        this.focus = false;
      } else if (event.isFirst === true) {
        this.dragging = this.__getDragging(event.evt);

        this.__updatePosition(event.evt);

        this.__updateValue();

        this.active = true;
        this.$emit('pan', 'start');
      } else {
        this.__updatePosition(event.evt);

        this.__updateValue();
      }
    },
    __onBlur: function __onBlur() {
      this.focus = false;
    },
    __onActivate: function __onActivate(evt) {
      this.__updatePosition(evt, this.__getDragging(evt));

      this.__updateValue();

      this.preventFocus = true;
      this.active = true;
      document.addEventListener('mouseup', this.__onDeactivate, true);
    },
    __onDeactivate: function __onDeactivate() {
      this.preventFocus = false;
      this.active = false;

      this.__updateValue(true);

      this.__onBlur();

      document.removeEventListener('mouseup', this.__onDeactivate, true);
    },
    __onMobileClick: function __onMobileClick(evt) {
      this.__updatePosition(evt, this.__getDragging(evt));

      this.__updateValue(true);
    },
    __onKeyup: function __onKeyup(evt) {
      if (keyCodes.includes(evt.keyCode)) {
        this.__updateValue(true);
      }
    },
    __getTextContainerStyle: function __getTextContainerStyle(ratio) {
      if (this.vertical === true) {
        return null;
      }

      var p = this.$q.lang.rtl !== this.reverse ? 1 - ratio : ratio;
      return {
        transform: "translateX(calc(".concat(2 * p - 1, " * ").concat(this.thumbSize, " / 2 + ").concat(50 - 100 * p, "%))")
      };
    },
    __getThumb: function __getThumb(h, thumb) {
      var thumbContent = [h('svg', {
        class: 'q-slider__thumb-shape absolute-full',
        attrs: {
          viewBox: '0 0 20 20',
          'aria-hidden': 'true'
        }
      }, [h('path', {
        attrs: {
          d: this.thumbPath
        }
      })]), h('div', {
        class: 'q-slider__focus-ring fit'
      })];

      if (this.label === true || this.labelAlways === true) {
        thumbContent.push(h('div', {
          class: this.pinClass + ' absolute fit no-pointer-events' + thumb.pinColor
        }, [h('div', {
          class: this.labelClass,
          style: {
            minWidth: this.thumbSize
          }
        }, [h('div', {
          class: this.textContainerClass,
          style: thumb.textContainerStyle
        }, [h('span', {
          class: thumb.textClass
        }, thumb.label)])])]));

        if (this.name !== void 0 && this.disable !== true) {
          this.__injectFormInput(thumbContent, 'push');
        }
      }

      return h('div', _objectSpread({
        class: thumb.classes,
        style: thumb.style
      }, thumb.nodeData), thumbContent);
    },
    __getContent: function __getContent(h, injectThumb) {
      var trackContent = [];
      this.innerTrackColor !== 'transparent' && trackContent.push(h('div', {
        key: 'inner',
        class: this.innerBarClass,
        style: this.innerBarStyle
      }));
      this.selectionColor !== 'transparent' && trackContent.push(h('div', {
        key: 'selection',
        class: this.selectionBarClass,
        style: this.selectionBarStyle
      }));
      this.markers !== false && trackContent.push(h('div', {
        key: 'marker',
        class: this.markerClass,
        style: this.markerStyle
      }));
      injectThumb(trackContent);
      var content = [h('div', {
        key: 'trackC',
        class: this.trackContainerClass,
        attrs: this.trackContainerAttrs,
        on: this.trackContainerEvents,
        directives: this.panDirectives
      }, [h('div', {
        class: this.trackClass,
        style: this.trackStyle
      }, trackContent)])];

      if (this.markerLabels !== false) {
        var action = this.switchMarkerLabelsSide === true ? 'unshift' : 'push';
        content[action](h('div', {
          key: 'markerL',
          class: this.markerLabelsContainerClass
        }, this.__getMarkerLabelsContent(h)));
      }

      return content;
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mouseup', this.__onDeactivate, true);
  }
};